import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/automations/code/$id')({
  component: CodeStepRedirect,
});

function CodeStepRedirect() {
  const { id } = Route.useParams();
  return <Navigate to="/apps/$appId" params={{ appId: id }} replace />;
}
